import React from 'react';

import styles from './donateButton.module.css';

const DonateButton = () => (
  <a className={styles.donateBtn} href="https://www.gofundme.com/f/help-jaymes-realize-his-german-fairytale-dream/donate">DONATE NOW</a>
);

export default DonateButton;
